module.exports = __webpack_public_path__ + "static/img/00054A_2_R_20200404_LC.7994927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00054A_2_R_20200404_LC.png
// module id = kW59
// module chunks = 0